import styled from "styled-components";

export const ModalBody = styled.div`
  text-align: center;
`;

export const Icone = styled.div`
  margin: auto;
  margin-bottom: 16px;
  font-size: 42px;

  svg {
    background-color: #fff5eb;
    color: #fe8f14;
    border-radius: 12px;
    padding: 10px;
  }
`;
